module.exports = __webpack_public_path__ + "static/media/Garasje.bbdb1204.PNG";